module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiny-text",
    staticStyle: {
      "font-weight": "initial"
    }
  }, [(_vm.years !== 'TODAY') ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.$options.filters.date(_vm.getStartDate(), 'DD.MM.YYYY')))]), _vm._v(" "), (_vm.br) ? _c('br') : _vm._e(), _vm._v(" "), _c('span', [_vm._v(" - " + _vm._s(_vm.$options.filters.date(_vm.getEndDate(), 'DD.MM.YYYY')))])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm.$options.filters.date(new Date(), 'DD.MM.YYYY')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e542b37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portfolio/DocTimeFrame.vue
// module id = 701
// module chunks = 0